import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-256bc149"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_th = _resolveComponent("oxd-th")!
  const _component_oxd_tr = _resolveComponent("oxd-tr")!
  const _component_oxd_thead = _resolveComponent("oxd-thead")!
  const _component_oxd_td = _resolveComponent("oxd-td")!
  const _component_oxd_tbody = _resolveComponent("oxd-tbody")!
  const _component_oxd_tfoot = _resolveComponent("oxd-tfoot")!
  const _component_oxd_table = _resolveComponent("oxd-table")!

  return (_openBlock(), _createBlock(_component_oxd_table, null, {
    default: _withCtx(() => [
      _createElementVNode("colgroup", null, [
        (_ctx.selectable)
          ? (_openBlock(), _createElementBlock("col", {
              key: 0,
              style: _normalizeStyle({width: _ctx.selector.width})
            }, null, 4))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
          return (_openBlock(), _createElementBlock("col", {
            style: _normalizeStyle({width: header.width}),
            key: header
          }, null, 4))
        }), 128))
      ]),
      _createVNode(_component_oxd_thead, null, {
        default: _withCtx(() => [
          _createVNode(_component_oxd_tr, null, {
            default: _withCtx(() => [
              (_ctx.selectable)
                ? (_openBlock(), _createBlock(_component_oxd_th, {
                    key: 0,
                    class: "oxd-padding-cell oxd-table-th"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAll) = $event)),
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChangeSelectAll && _ctx.onChangeSelectAll(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.selectedAll]
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
                return (_openBlock(), _createBlock(_component_oxd_th, {
                  class: "oxd-padding-cell oxd-table-th",
                  key: header
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(header.title), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_oxd_tbody, { "with-strip": _ctx.withStrip }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createBlock(_component_oxd_tr, {
              key: item,
              clickable: _ctx.clickable,
              onClick: ($event: any) => (_ctx.onClick(item)($event))
            }, {
              default: _withCtx(() => [
                (_ctx.selectable)
                  ? (_openBlock(), _createBlock(_component_oxd_td, {
                      key: 0,
                      class: "oxd-padding-cell"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          value: index,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkedItems) = $event)),
                          onClick: ($event: any) => (_ctx.onClickCheckbox(item, $event))
                        }, null, 8, _hoisted_1), [
                          [_vModelCheckbox, _ctx.checkedItems]
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
                  return (_openBlock(), _createBlock(_component_oxd_td, {
                    class: "oxd-padding-cell",
                    key: header
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item[header.name]), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1032, ["clickable", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["with-strip"]),
      _createVNode(_component_oxd_tfoot)
    ]),
    _: 1
  }))
}